import { z } from 'zod';
import { majorRegionsSchema } from './major-region.schema';
import { regionDetailsSchema } from './region-details.schema';

export const fullRegionSchema = z.object({
  majorRegions: majorRegionsSchema,
  regionDetails: regionDetailsSchema,
});

export const fullRegionsSchema = z.array(fullRegionSchema);

export type FullRegion = z.infer<typeof fullRegionSchema>;
